// https://www.osiux.ws/blog/get-rid-of-huge-font-awesome-icons-on-gatsby
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

config.autoAddCss = false;
